import { FormGroup, Input, Label } from "reactstrap";

import PropTypes from "prop-types";
import React from "react";

const DropDown = ({
  label,
  name,
  error,
  onChange,
  options,
  selectLabel,
  style,
  containerStyle,
  className,
  containerClassName,
  ...props
}) => {
  return (
    <FormGroup className={containerClassName} style={containerStyle}>
      {label && (
        <Label htmlFor="exampleSelect" style={{ fontWeight: "bold" }}>
          {label}
        </Label>
      )}
      <Input
        style={style}
        className={className}
        type="select"
        name={name}
        invalid={error}
        onChange={(e) => (onChange ? onChange(e) : null)}
        {...props}>
        <option
          value={""}
          disabled={
            props.value && options && options.length > 1 ? true : false
          }>
          {selectLabel || "Select"}
        </option>
        {options &&
          options.length &&
          options.map((opt, idx) => (
            <option key={idx} value={opt.value}>
              {opt.label}
            </option>
          ))}
      </Input>
    </FormGroup>
  );
};

export default DropDown;

DropDown.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  selectLabel: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.any,
  containerStyle: PropTypes.any,
  className: PropTypes.string,
  containerClassName: PropTypes.string
};
